<template lang="html">
<section id="team" class="padded">
	<div class="content">
		<h1 v-if="about[currentLang].teamTitle" class="discret dark">{{ about[currentLang].teamTitle }}</h1>
		<h1 v-else class="discret dark">{{ $t("team") }}</h1>
		<transition name="slide-fade">
			<div class="carousel grid c-5" v-if="sectionLoaded">
				<!-- <agile v-if="about[currentLang].teamMembers.length" :dots="false" ref="team" :options="teamOptions" :navButtons="false"> -->
					<div class="slide" v-for="(member,index) in about[currentLang].teamMembers" :key="index">
						<figure class="figure--square" v-if="member.portrait">
							<img 
							v-lazy="member.portrait.url" 
							:srcset="member.portrait.srcset"
							sizes="(min-width: 700px) 50vw, (min-width: 900px) 33.3333vw, (min-width: 1024px) 50vw, (min-width: 1200px) 33.3333vw, 100vw" 
							:alt="member.portrait.alt ? member.portrait.alt : member.portrait.filename"
							/>
						</figure>
						<span class="team--name">{{member.name}}</span>
						<span class="team--job">{{member.job}}</span>
						<p v-html="member.description"></p>
					</div>
				<!-- </agile> -->
			</div>
		</transition>
	</div>
</section>
</template>

<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import imgHandler  from '@/mixins/imgHandler.js'

export default {
	mixins: [scrollBehavior, imgHandler],
	props: ['about', 'site', 'currentLang'],
	data () {
		return {
			sectionLoaded: false,
			teamOptions: {
				responsive: [
					{
						breakpoint: 300,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 700,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 1250,
						settings: {
							slidesToShow: 5
						}
					},
				]
			}
		}
	},
	watch:{
		visible(visible){
			if(visible){
				this.sectionLoaded = true;
			}
		}
	},
}
</script>

<style lang="scss">
	#team{
		background-color:#fff;
		width:100%;
		overflow:hidden;
		padding-bottom:7rem;
		h1{
			margin: 3rem 0;
		}
		.carousel{
			grid-gap: 4.6rem;
			grid-row-gap: 2rem;
			.slide{
				@media screen and (max-width:768px){
					margin-bottom: 4rem;
				}
			}
		}
		.agile{
			position:relative;
			@media screen and (max-width:768px){
				width:150%;
			}
			.agile__slide{
				@include align-self(flex-start);
				padding: 0 .5rem;
				@media screen and (min-width:768px){
					padding: 0 2.3rem;
				}
			}
			.agile__actions{
				.agile__nav-button{
					border:none;
					background-color:none;
					position: absolute;
					cursor:pointer;
					font-size:0rem;
					top: 50%;
					width: 35px;
					height: 35px;
					&.agile__nav-button--next{
						background:url('../assets/img/arrow-next.png') no-repeat center;
						background-size:cover;
						right: 3rem;
					}
					&.agile__nav-button--prev{
						background:url('../assets/img/arrow-prev.png') no-repeat center;
						background-size:cover;
						right: 6rem;
					}
					@media screen and (min-width:800px){
						top:55%;
					}
					@media screen and (min-width:1024px){
						top:45%;
						width: 45px;
						height: 45px;
					}
					@media screen and (min-width:1250px){
						top: 14rem;
						@include transition(opacity .3s ease);
						&:hover{
							opacity:.7;
						}
						&.agile__nav-button--next{
							right: 2rem;
						}
						&.agile__nav-button--prev{
							right:5.5rem;
						}
					}
				}
			}
		}
		.team--name{
			display:block;
			font-size:1.333rem;
			letter-spacing: 0.31px;
			margin: 2rem 0 1rem 0;
			line-height: 1.2;
			font-family: 'surtSemiBold_extended', Helvetica, Arial, sans-serif;
			width: 110%;
		}
		.team--job{
			color:rgba(32, 34, 38, .8);
			font-size:.9333rem;
			letter-spacing:0.09px;
			+ p{
				letter-spacing: .06px;
				line-height: 1.4rem;
			}
		}
	}
</style>
